// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3eTYW","inner":"Footer_inner__m8X5_"};